import React from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'
import { Icon } from '../../../Shared/Icons'

const LESSONS = [
  {
    icon: 'refresh',
    title: 'What Is Arbitrage?',
    desc: 'Arbitrage means buying an asset where its price is lower and selling it where it is higher, capturing the difference. Because these gaps are small and close quickly, it depends on speed rather than market direction.',
  },
  {
    icon: 'network',
    title: 'Cross-Exchange Price Gaps',
    desc: 'The same asset can briefly trade at different prices across exchanges due to differences in liquidity, order flow, and regional demand. The Arbitrade Bot watches these gaps across 50+ exchanges simultaneously.',
  },
  {
    icon: 'bot',
    title: 'Why Automation Matters',
    desc: 'Profitable spreads often exist for only a few seconds. A human trader cannot reliably watch dozens of order books at once — automated execution is what makes arbitrage viable at scale.',
  },
  {
    icon: 'shield',
    title: 'Risk Is Never Zero',
    desc: 'Arbitrage reduces exposure to overall market direction, but execution delays, exchange downtime, and sudden liquidity changes can still turn a trade unprofitable. Automation manages risk — it does not eliminate it.',
  },
  {
    icon: 'trendUp',
    title: 'Futures & Funding-Rate Spreads',
    desc: 'Beyond simple spot arbitrage, price gaps also appear between spot and perpetual futures markets, often tied to funding rates. These spreads behave differently and are tracked as a separate strategy.',
  },
  {
    icon: 'barChart',
    title: 'Reading Your Profit History',
    desc: 'Every executed trade is logged with its exchange pair, price, and payout in your dashboard. Reviewing Profit History regularly helps you understand how your subscription tier is actually performing.',
  },
]

export default function Academy() {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xac-lesson-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 24px; }
      `}</style>
      <PublicNav active="Resources" />

      <section style={{ padding: '130px 24px 60px', textAlign: 'center', background: C.dark, color: C.ltx, borderBottom: `1px solid ${C.dbdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Learn</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 14px' }}>Xperia Academy</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.ltx2, maxWidth: '560px', margin: '0 auto' }}>Plain-language lessons on how automated crypto arbitrage actually works, from first principles to reading your own dashboard.</p>
      </section>

      <section style={{ padding: '72px 24px', maxWidth: '1100px', margin: '0 auto' }}>
        <div className="xac-lesson-grid">
          {LESSONS.map(l => (
            <div key={l.title} style={{ background: C.light, border: `1px solid ${C.bdr}`, borderRadius: '14px', padding: '24px' }}>
              <div style={{ color: C.primary, marginBottom: '14px' }}><Icon name={l.icon} size={30} strokeWidth={1.5} /></div>
              <div style={{ fontFamily: fOutfit, fontWeight: 600, fontSize: '18px', color: C.tx, marginBottom: '8px' }}>{l.title}</div>
              <p style={{ fontSize: '14px', color: C.tx2, lineHeight: 1.6, margin: 0 }}>{l.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: '60px 24px 100px', textAlign: 'center' }}>
        <Link to="/trading/cryptocurrencies" style={{ display: 'inline-block', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '13px', padding: '12px 24px', borderRadius: '999px', textDecoration: 'none', marginRight: '12px' }}>Explore Crypto Trading</Link>
        <Link to="/resources/glossary" style={{ display: 'inline-block', border: `1px solid ${C.bdr}`, color: C.tx2, fontWeight: 700, fontSize: '13px', padding: '12px 24px', borderRadius: '999px', textDecoration: 'none' }}>View Glossary</Link>
      </section>

      <PublicFooter />
    </div>
  )
}
